// Shared, bounded language controls. Language is not an accent or translation request.
export const SPEECH_LANGUAGES = {
  en: 'English', fr: 'French', es: 'Spanish', de: 'German', it: 'Italian', pt: 'Portuguese',
  nl: 'Dutch', el: 'Greek', ar: 'Arabic', hi: 'Hindi', ja: 'Japanese', ko: 'Korean',
  zh: 'Chinese (Mandarin)', ru: 'Russian', pl: 'Polish', tr: 'Turkish', vi: 'Vietnamese',
  id: 'Indonesian', ro: 'Romanian', ta: 'Tamil', te: 'Telugu', bn: 'Bangla', mr: 'Marathi',
  uk: 'Ukrainian', he: 'Hebrew', cs: 'Czech', da: 'Danish', hu: 'Hungarian', fil: 'Filipino',
} as const;
export type SpeechLanguage = 'auto' | keyof typeof SPEECH_LANGUAGES;
export function validateSpeechLanguage(value: unknown): keyof typeof SPEECH_LANGUAGES | undefined {
  if (value === undefined || value === null || value === 'auto') return undefined;
  if (typeof value !== 'string' || !Object.hasOwn(SPEECH_LANGUAGES, value)) throw new Error('Unsupported speech language.');
  return value as keyof typeof SPEECH_LANGUAGES;
}
export function languageOptions(options: Record<string, unknown> | null | undefined): Record<string, string> {
  if (options?.speech_language === 'auto') return { speech_language: 'auto' };
  const language = validateSpeechLanguage(options?.speech_language);
  return language ? { speech_language: language } : {};
}
export function withLanguageDefault(options: Record<string, unknown>, fallback: unknown): Record<string, unknown> {
  return { ...options, ...(Object.hasOwn(options, 'speech_language') ? languageOptions(options) : languageOptions({ speech_language: fallback })) };
}
export function languageInstruction(language: keyof typeof SPEECH_LANGUAGES) {
  return `Speak this text verbatim in ${SPEECH_LANGUAGES[language]}.`;
}
